module.exports = __webpack_public_path__ + "gy.svg?f1a8b3460583bf77661ae1996b472bda";